module.exports = __webpack_public_path__ + "b37e7038c57ff54f2a3b5c59bde28ef2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-25.png
// module id = 2198
// module chunks = 0